import type { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { sfaaCodesQueryKey } from "../sfaa-code.keys";

export const useFetchSfaaCodes = (
	params: Dtos.SfaaCode.List.Request = {},
	enabled: boolean = true,
) => {
	const { get } = useRequest();

	const { data, error, isLoading, isFetching, refetch } = useQuery({
		queryKey: sfaaCodesQueryKey(params),
		enabled,
		queryFn: async () => {
			const search = new URLSearchParams();
			if (params.type) search.set("type", params.type);
			if (params.subType) search.set("subType", params.subType);
			if (params.class) search.set("class", params.class);
			if (params.subClass) search.set("subClass", params.subClass);
			const query = search.toString();
			return await get<Dtos.SfaaCode.List.Response>(
				`/v2/admin/sfaa-codes${query === "" ? "" : `?${query}`}`,
			);
		},
	});

	return {
		sfaaCodes: data,
		sfaaCodesError: error,
		sfaaCodesIsLoading: isLoading,
		sfaaCodesIsFetching: isFetching,
		refetchSfaaCodes: refetch,
	};
};
